import { getToken, Status } from '@optimus-web/common';
import { InputWrapperProps } from './style';

type FieldState = 'default' | 'disabled' | 'error' | 'focused' | 'readOnly';

const getState = ({ $disabled, status, focused, readOnly }: InputWrapperProps) => {
    let state: FieldState = 'default';

    if (readOnly) {
        state = 'readOnly';
    } else if (status === Status.Error && !$disabled) {
        state = 'error';
    } else if ($disabled) {
        state = 'disabled';
    } else if (focused) {
        state = 'focused';
    }

    return state;
};

export const getTextColor = (props: InputWrapperProps) => {
    const textColorTokens = {
        readOnly: getToken('textStaticSecondary'),
        focused: getToken('textStaticPrimary'),
        error: getToken('textStaticPrimary'),
        disabled: getToken('textDisabled'),
        default: 'inherit',
    };

    return textColorTokens[getState(props)];
};

export const getBorderColor = (props: InputWrapperProps) => {
    const borderColorTokens = {
        readOnly: getToken('borderDisabled'),
        focused: getToken('borderInteractiveFocus'),
        error: getToken('borderInteractiveInputError'),
        disabled: getToken('borderDisabled'),
        default: getToken('borderInteractiveInputDefault'),
    };

    return borderColorTokens[getState(props)];
};
